import FantasyJoinedUsers from './FantasyJoinedUsers';

export default FantasyJoinedUsers;
